/** = Functionality */
/** @TODO: see if this can be set at listings Data Composer level */
export function getAirlinesForThisSlice(segmentList, airlines) {
  const segmentAirlineSet = segmentList.reduce(
    (acc, listItem) => acc.add(listItem.marketingAirline),
    new Set()
  )

  return Array.from(segmentAirlineSet).reduce((acc, airline) => {
    const foundAirline = airlines?.find((item) => item.code === airline)
    if (foundAirline) {
      acc.push(foundAirline)
    }
    return acc
  }, [])
}
